let _onTokenExpired = null;

export function registerTokenExpiredHandler(handler) {
  _onTokenExpired = handler;
}

export function notifyTokenExpired() {
  if (typeof _onTokenExpired === "function") {
    _onTokenExpired();
  }
}

export function clearTokenExpiredHandler() {
  _onTokenExpired = null;
}
